import React from 'react';
import { FeedbackVariants } from '@indigo-ag/component-module/dist/commonjs/shared/theme/theme-helpers/feedback';
import i18next from 'i18next';
import { BacenItem } from '../../../../phases/Phase1.utils';
import { SerasaBacenCard } from '../SerasaBacenCard';
import { BacenRestrictionsDetailModal } from './BacenRestrictionDetailModal';
import { BacenStatus } from '@indigo-ag/schema';

interface BacenAnnotationCardProps {
  annotationType: string;
  report: BacenItem;
}

const STATUS_LABEL_MAP: { [key in BacenStatus]: string } = {
  CLEARED: i18next.t('backgroundCheckStepStatus_Passed'),
  FAILED: i18next.t('backgroundCheckStepStatus_Failed'),
  UNRESOLVED: i18next.t('backgroundCheckStepStatus_Processing'),
  GET_SCR_DATA: i18next.t('backgroundCheckStepStatus_Processing')
};

const STATUS_VARIANT_MAP: { [key in BacenStatus]: FeedbackVariants } = {
  CLEARED: 'success',
  FAILED: 'error',
  UNRESOLVED: 'warning',
  GET_SCR_DATA: 'warning'
};

const MESSAGE_MAP: { [key in BacenStatus]: string } = {
  CLEARED: i18next.t('serasaAnnotationCard_message'),
  FAILED: i18next.t('serasaAnnotationCard_messageFailed'),
  UNRESOLVED: i18next.t('serasaAnnotationCard_messageEmpty'),
  GET_SCR_DATA: i18next.t('serasaAnnotationCard_messageEmpty')
};

export const BacenAnnotationCard = ({ annotationType, report }: BacenAnnotationCardProps) => {
  const showDetailModal = (open: boolean, onRequestClose: () => void) => (
    <BacenRestrictionsDetailModal isOpen={open} onRequestClose={onRequestClose} report={report} />
  );

  return (
    <SerasaBacenCard
      report={{
        annotationType,
        date: report.dateReport,
        statusMessage: MESSAGE_MAP[report.status]
      }}
      statusTag={{
        label: STATUS_LABEL_MAP[report.status],
        variant: STATUS_VARIANT_MAP[report.status]
      }}
      modal={{ show: showDetailModal }}
    />
  );
};
